/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Ownership_TransferredInputs */



/**
* | output |
* | --- |
* | "Ownership transferred" |
*
* @param {Audit_Details_Member_Ownership_TransferredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_ownership_transferred = /** @type {((inputs?: Audit_Details_Member_Ownership_TransferredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Ownership_TransferredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Besitz übertragen")
	return /** @type {LocalizedString} */ ("Ownership transferred")
});